import { getIconPathString } from "components/icons/pathString"

const BASE_FONT_FAMILY = "Manrope"

const defaultMapTheme = [
  {
    featureType: "origin-marker",
    elementType: "geometry",
    symbol: [
      {
        markerType: "ellipse",
        markerFill: "#000000",
        markerLineWidth: 0,
        markerFillOpacity: 0.1,
        markerWidth: 30,
        markerHeight: 30,
      },
      {
        markerType: "ellipse",
        markerFill: "#ffffff",
        markerLineColor: "#000000",
        markerLineWidth: 2,
        markerWidth: 15,
        markerHeight: 15,
      },
    ],
  },
  {
    featureType: "navigation-path",
    elementType: "geometry",
    symbol: [
      {
        lineColor: "#6393f2",
        lineOpacity: 0.2,
        lineCap: "round",
        lineJoin: "round",
        lineWidth: {
          stops: [
            [18, 6],
            [20, 8],
          ],
        },
      },
      {
        lineColor: "#6393f2",
        lineOpacity: 1,
        lineCap: "round",
        lineJoin: "round",
        lineWidth: {
          stops: [
            [18, 3],
            [20, 4],
          ],
        },
      },
    ],
  },
  {
    featureType: "navigation-path-start",
    elementType: "geometry",
    symbol: {
      markerType: "ellipse",
      markerWidth: {
        stops: [
          [17, 4],
          [18, 6],
        ],
      },
      markerHeight: {
        stops: [
          [17, 4],
          [18, 6],
        ],
      },
      markerLineWidth: 1,
      markerLineColor: "#6393f2",
      markerFill: "#fff",
      markerPlacement: "vertex-first",
    },
  },
  {
    featureType: "navigation-path-end",
    elementType: "geometry",
    symbol: {
      markerType: "ellipse",
      markerWidth: {
        stops: [
          [17, 4],
          [18, 6],
        ],
      },
      markerHeight: {
        stops: [
          [17, 4],
          [18, 6],
        ],
      },
      markerLineWidth: 1,
      markerLineColor: "#6393f2",
      markerFill: "#fff",
      markerPlacement: "vertex-last",
    },
  },
  {
    featureType: "pin-marker",
    elementType: "geometry",
    symbol: {
      markerType: "path",
      markerPath: `M5.7,15.1L5.7,15.1C5.6,15,4.3,13.5,3,11.6c-0.7-1-1.3-2-1.8-3.1c-0.5-1.1-0.8-2.1-0.8-3c0-2.9,2.5-5.3,5.5-5.3  c3,0,5.5,2.4,5.5,5.3c0,0.9-0.3,1.9-0.8,3c-0.5,1.1-1.1,2.1-1.8,3.1c-1.3,1.9-2.7,3.4-2.8,3.5l0,0C6,15.2,5.8,15.2,5.7,15.1z   M2.7,5.6c0,1.7,1.5,3.1,3.2,3.1c1.8,0,3.2-1.4,3.2-3.1c0-1.7-1.5-3.1-3.2-3.1S2.7,3.9,2.7,5.6z M8.2,22.1c0,1.2-1,2.2-2.3,2.2c-1.3,0-2.3-1-2.3-2.2c0-1.2,1-2.2,2.3-2.2C7.2,20,8.2,20.9,8.2,22.1z`,
      markerFill: "#FF0000",
      markerPathWidth: 12,
      markerPathHeight: 25,
      markerLineWidth: 0.5783,
      markerLineColor: "#fff",
      markerWidth: {
        stops: [
          [18, 12],
          [19, 24],
          [20, 36],
        ],
      },
      markerHeight: {
        stops: [
          [18, 25],
          [19, 50],
          [20, 75],
        ],
      },
    },
  },
  {
    featureType: "hilight-polygonal",
    elementType: "geometry",
    symbol: { polygonFill: "#787878" },
  },
  {
    featureType: "hilight-marker",
    elementType: "geometry",
    symbol: [
      {
        markerWidth: {
          stops: [
            [18, 5],
            [19, 25],
            [20, 45],
          ],
        },
        markerHeight: {
          stops: [
            [18, 5],
            [19, 25],
            [20, 45],
          ],
        },
      },
      {
        markerWidth: {
          stops: [
            [19, 10],
            [20, 35],
          ],
        },
        markerHeight: {
          stops: [
            [19, 10],
            [20, 35],
          ],
        },
        markerDy: -8,
      },
    ],
  },
  {
    featureType: "user-location",
    elementType: "geometry",
    symbol: {
      start: [
        {
          markerType: "ellipse",
          markerFill: "#077dff",
          markerLineWidth: 0,
          markerFillOpacity: 0.2,
          markerWidth: 30,
          markerHeight: 30,
        },
        {
          markerType: "ellipse",
          markerFill: "#077dff",
          markerLineColor: "#ffffff",
          markerLineWidth: 2,
          markerWidth: 20,
          markerHeight: 20,
        },
      ],
      end: [
        {
          markerFillOpacity: 0.4,
          markerWidth: 40,
          markerHeight: 40,
        },
        {
          markerWidth: 20,
          markerHeight: 20,
        },
      ],
    },
  },
  {
    featureType: "last-user-location",
    elementType: "geometry",
    options: {
      text: "Last\nScanned",
    },
    symbol: [
      {
        markerType: "ellipse",
        markerFill: "#fff",
        markerLineWidth: 0,
        markerFillOpacity: 0.2,
        markerWidth: 30,
        markerHeight: 30,
      },
      {
        markerType: "ellipse",
        markerFill: "#A4A4A4",
        markerLineColor: "#ffffff",
        markerLineWidth: 2,
        markerWidth: 20,
        markerHeight: 20,
      },
      {
        textFaceName: BASE_FONT_FAMILY,
        textName: "{text}",
        textWeight: "normal",
        textStyle: "normal",
        textFill: "#666666",
        textHaloFill: "#ffffff",
        textLineSpacing: 0,
        textHaloRadius: {
          stops: [
            [20, 1],
            [21, 2],
          ],
        },
        textDy: {
          stops: [
            [19, -15],
            [20, -35],
          ],
        },
        textSize: {
          stops: [
            [19, 0],
            [20, 16],
            [22, 18],
          ],
        },
      },
    ],
  },
  {
    featureType: "venue",
    elementType: "geometry",
    symbol: {
      polygonFill: "rgba(213, 213, 213, 0.5)",
      lineWidth: 0,
    },
  },
  {
    featureType: "level",
    elementType: "geometry",
    symbol: {
      lineColor: "#E7E7ED",
      polygonFill: "#F5F7F9",
      lineWidth: 2,
      shadowBlur: 4,
      shadowColor: "rgba(198,199,200, 0.5)",
      shadowOffsetX: 2,
      shadowOffsetY: 6,
    },
  },
  {
    featureType: "unit",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      lineWidth: 2,
      polygonFill: "#CECECE",
    },
  },
  {
    featureType: "unit.elevator",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.restroom",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.restroom.female",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.restroom.male",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "footprint",
    elementType: "material",
    symbol: {
      color: "#b3aca9",
      transparent: true,
    },
  },
  {
    featureType: "unit.escalator",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.elevator",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.stairs",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#636363",
    },
  },
  {
    featureType: "unit.walkway",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      polygonFill: "#969696",
    },
  },
  {
    featureType: "unit.footbridge",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      polygonFill: "#969696",
    },
  },
  {
    featureType: "unit.room",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      lineWidth: 2,
      polygonFill: "#CECECE",
      polygonOpacity: 0.7,
    },
  },
  {
    featureType: "unit.parking",
    elementType: "geometry",
    symbol: {
      lineColor: "#b3aca9",
      lineWidth: 1,
      polygonFill: "#f0f0f0",
    },
  },
  {
    featureType: "unit.nonpublic",
    elementType: "geometry",
    symbol: {
      lineWidth: 1,
      lineColor: "#D7D7D7",
      polygonFill: "#F7F7F7",
    },
  },
  {
    featureType: "unit.opentobelow",
    elementType: "geometry",
    symbol: {
      lineWidth: 0,
      lineColor: "transparent",
      polygonFill: "transparent",
    },
  },
  {
    featureType: "kiosk",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      polygonFill: "#CECECE",
      polygonOpacity: 0.7,
      lineWidth: 2,
    },
  },
  {
    featureType: "fixture",
    elementType: "geometry",
    symbol: {
      lineColor: "#969696",
      polygonFill: "#CECECE",
      polygonOpacity: 0.7,
      lineWidth: 2,
    },
  },
  {
    featureType: "fixture.vegetation",
    elementType: "geometry",
    symbol: {
      polygonFill: "#A3D220",
      polygonOpacity: 0.7,
      lineWidth: 0,
    },
  },
  {
    featureType: "fixture.water",
    elementType: "geometry",
    symbol: {
      lineWidth: 0,
      polygonFill: "#56ACDF",
      polygonOpacity: 0.7,
    },
  },
  {
    featureType: "opening",
    elementType: "geometry",
    symbol: {
      lineWidth: {
        stops: [
          [18, 0],
          [19, 1],
          [20, 5],
        ],
      },
    },
  },
  {
    featureType: "opening.pedestrian",
    elementType: "geometry",
    symbol: {
      lineColor: "#CECECE",
    },
  },
  {
    featureType: "opening.pedestrian.principal",
    elementType: "geometry",
    symbol: {
      lineColor: "#333333",
    },
  },
  {
    featureType: "section",
    elementType: "geometry",
    symbol: {
      textFaceName: BASE_FONT_FAMILY,
      lineColor: "#EAD7D7",
      lineWidth: 1,
      polygonFill: "#F7F0F0",
    },
  },
  {
    featureType: "section.eatingdrinking",
    elementType: "geometry",
    symbol: {
      polygonFill: "#FFBF7F",
    },
  },
  {
    featureType: "section.eatingdrinking",
    elementType: "geometry",
    symbol: {
      lineWidth: 0,
      polygonFill: "#FFBF7F",
    },
  },
  {
    featureType: "section.vegetation",
    elementType: "geometry",
    symbol: {
      lineColor: "#A4B494",
      polygonFill: "#A4B494",
    },
  },
  {
    featureType: "section.seating",
    elementType: "geometry",
    symbol: {
      lineColor: "#A4B494",
      polygonFill: "#A4B494",
    },
  },
  {
    featureType: "amenity",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M45.5 0h-43v43h16.2l5.9 5 5.8-5h15.1z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: {
        stops: [
          [18, 0],
          [19, 15],
          [20, 30],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 15],
          [20, 30],
        ],
      },
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "amenity",
    elementType: "label.marker",
    symbol: {
      markerType: "path",
      markerFill: "#FFFFFF",
      markerPathWidth: 24,
      markerPathHeight: 24,
      markerWidth: {
        stops: [
          [18, 0],
          [19, 12],
          [20, 24],
        ],
      },
      markerHeight: {
        stops: [
          [18, 0],
          [19, 12],
          [20, 24],
        ],
      },
      markerDy: {
        stops: [
          [18, 0],
          [20, -4],
        ],
      },
    },
  },
  {
    featureType: "amenity.elevator",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("elevator"),
    },
  },
  {
    featureType: "amenity.escalator",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("escalator"),
    },
  },
  {
    featureType: "amenity.information",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("information"),
    },
  },
  {
    featureType: "amenity.atm",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("atm"),
    },
  },
  {
    featureType: "amenity.stairs",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("stairs"),
    },
  },
  {
    featureType: "amenity.currencyexchange",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("currencyexchange"),
    },
  },
  {
    featureType: "amenity.restroom",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("restroom"),
    },
  },
  {
    featureType: "amenity.restroom.male",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("restroom.male"),
    },
  },
  {
    featureType: "amenity.restroom.female",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("restroom.female"),
    },
  },
  {
    featureType: "amenity.restroom.wheelchair",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("restroom.wheelchair"),
    },
  },
  {
    featureType: "amenity.parking",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("parking"),
    },
  },
  {
    featureType: "amenity.prayerroom",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("prayerroom"),
    },
  },
  {
    featureType: "amenity.firstaid",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("firstaid"),
    },
  },
  {
    featureType: "amenity.smokingarea",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("smokingarea"),
    },
  },
  {
    featureType: "amenity.bus",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("bus"),
    },
  },
  {
    featureType: "amenity.taxi",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("taxi"),
    },
  },
  {
    featureType: "amenity.parking.bicycle",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("parking.bicycle"),
    },
  },
  {
    featureType: "amenity.parking.motorcycle",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("parking.motorcycle"),
    },
  },
  {
    featureType: "amenity.wheelchair",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("wheelchair"),
    },
  },
  {
    featureType: "amenity.landmark",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("landmark"),
    },
  },
  {
    featureType: "occupant-logo",
    elementType: "label.base",
    symbol: {
      markerType: "path",
      markerPath: "M45.5 0h-43v43h16.2l5.9 5 5.8-5h15.1z",
      markerPathWidth: 48,
      markerPathHeight: 48,
      markerWidth: 40,
      markerHeight: 40,
      markerFill: "#044B7F",
    },
  },
  {
    featureType: "occupant-logo",
    elementType: "label.marker",
    symbol: {
      markerWidth: 32,
      markerHeight: 32,
      markerDy: -6,
    },
  },
  {
    featureType: "amenity.rail.muni",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("rail.muni"),
    },
  },

  {
    featureType: "amenity.boardinggate.ferry",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("boardinggate.ferry"),
    },
  },
  {
    featureType: "amenity.ticketing",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("ticketing"),
    },
  },
  {
    featureType: "amenity.meetingpoint",
    elementType: "label.marker",
    symbol: {
      markerPath: getIconPathString("meetingpoint"),
    },
  },
  {
    featureType: "occupant-name",
    elementType: "label.marker",
    symbol: {
      textFaceName: BASE_FONT_FAMILY,
      textWeight: "normal",
      textStyle: "normal",
      textFill: "#666666",
      textHaloFill: "#ffffff",
      textLineSpacing: 0,
    },
  },
  {
    featureType: "occupant-name-1",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 12],
          [19, 14],
          [20, 16],
          [22, 18],
        ],
      },
    },
  },
  {
    featureType: "occupant-name-2",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 16],
          [20, 16],
          [22, 18],
        ],
      },
    },
  },
  {
    featureType: "occupant-name-3",
    elementType: "label.marker",
    symbol: {
      textSize: {
        stops: [
          [18, 0],
          [19, 0],
          [20, 16],
          [22, 18],
        ],
      },
    },
  },
  {
    featureType: "highlighted-marker",
    elementType: "geometry",
    symbol: [
      {
        markerWidth: {
          stops: [
            [18, 30],
            [19, 35],
            [20, 45],
          ],
        },
        markerHeight: {
          stops: [
            [18, 30],
            [19, 35],
            [20, 45],
          ],
        },
        markerFill: "#C60000",
      },
      {
        markerWidth: {
          stops: [
            [18, 20],
            [19, 25],
            [20, 35],
          ],
        },
        markerHeight: {
          stops: [
            [18, 20],
            [19, 25],
            [20, 35],
          ],
        },
        markerDy: -7,
      },
    ],
  },
]

export default defaultMapTheme
